import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Share2, Heart } from 'lucide-react';

const FinalPage: React.FC = () => {
  const navigate = useNavigate();

  const handleShare = async () => {
    try {
      await navigator.share({
        title: 'Médiation',
        text: 'Découvrez Médiation, une plateforme pour résoudre vos désaccords avec bienveillance.',
        url: window.location.origin
      });
    } catch (err) {
      console.error('Error sharing:', err);
    }
  };

  return (
    <div className="max-w-2xl mx-auto text-center animate-fade-in">
      <div className="flex justify-center mb-8">
        <Heart className="text-red-500" size={64} />
      </div>

      <h1 className="text-3xl md:text-4xl font-bold mb-6">
        Merci d'avoir utilisé Médiation 💙
      </h1>

      <p className="text-xl text-slate-600 mb-12">
        Nous espérons que cette médiation vous a aidé à avancer vers une résolution apaisée.
      </p>

      <div className="space-y-4">
        <button
          onClick={handleShare}
          className="btn-primary flex items-center gap-2 mx-auto"
        >
          <Share2 size={18} />
          Partager avec vos amis
        </button>

        <button
          onClick={() => navigate('/')}
          className="btn-secondary mx-auto"
        >
          Retour à l'accueil
        </button>
      </div>
    </div>
  );
};

export default FinalPage